<template>
<div class="container py-3 mb-5">
  <div class="row">
    <div class="col-md-3" style="hieght:500px">
      <div class="columns">
        <ul class="price">
            <li class="header bg-primary">FREE</li>
            <li class="grey">$ 0 / month </li>
            <li>1000 incoming messages*</li>
            <li>Bot Creator branding</li>
            <li>Unlimited number of bots</li>
            <li>Unlimited storage of data</li>
            <li>Unlimited number of subscribers</li>
            <li>Unlimited outgoing messages</li>
            <li>Unlimited broadcast messages</li>
            
        </ul>
      </div>
    </div>
    <div class="col-md-3">
      <div class="columns">
        <ul class="price">
            <li class="header bg-info">BASIC</li>
            <li class="grey">$ 5 / month </li>
            <li>5000 incoming messages*</li>
            <li>Bot Creator branding</li>
            <li>All features available in Free Plan</li>
            <li class="btn btn-block btn-info" @click="upgrade_msg = !upgrade_msg">TRY NOW</li>
        </ul>
        <AlertLinkND v-if="upgrade_msg" link="https://t.me/hackspider" text="Please contact @hackspider to upgrade your account. click here"></AlertLinkND>
      </div>
    </div>
    <div class="col-md-3">
      <div class="columns">
        <ul class="price">
            <li class="header bg-success">PRO</li>
            <li class="grey">$ 10 / month</li>
            <li>10000 incoming messages</li>
            <li>No branding</li>
            <li>Technical support</li>
            <li>All features available in Free Plan</li>
            <li class="btn btn-block btn-success" @click="upgrade_msg = !upgrade_msg">TRY NOW</li>
        </ul>
      <AlertLinkND v-if="upgrade_msg" link="https://t.me/hackspider" text="Please contact @hackspider to upgrade your account. click here"></AlertLinkND>
      </div>
    </div>
    <div class="col-md-3">
      <div class="columns">
        <ul class="price">
            <li class="header bg-warning">ULTIMATE</li>
            <li class="grey">$ 30 / month</li>
            <li>We will create and maintain your bot^</li>
            <li>30000 messages</li>
            <li>No branding</li>
            <li>Technical support</li>
            <li>All features available in Free Plan</li>
            <li class="btn btn-block btn-warning" @click="upgrade_msg = !upgrade_msg">TRY NOW</li>
        </ul>
      <AlertLinkND v-if="upgrade_msg" link="https://t.me/hackspider" text="Please contact @hackspider to upgrade your account. click here."></AlertLinkND>
      </div>
    </div>
  </div>
  
  <i class="p-2">*Incoming message: any action generated from the user in private or group or channel</i>
  <br>
  <i class="p-2">^30$/bot for creating and mainitaining</i>

</div>

</template>

<script>
import AlertLinkND from "@/components/AlertLinkND.vue";

export default {
  name: 'PricingTable',
  components: {
    AlertLinkND
  },
  data: function(){
    return{
      upgrade_msg: false
    }
  }

}
</script>

<style>
* {
  box-sizing: border-box;
}

/* Create three columns of equal width */
.columns {
  float: left;
  width: 100%;
  padding: 8px;
}

/* Style the list */
.price {
  list-style-type: none;
  border: 1px solid #eee;
  margin: 0;
  padding: 0;
  -webkit-transition: 0.3s;
  transition: 0.3s;
}

/* Add shadows on hover */
.price:hover {
  box-shadow: 0 8px 12px 0 rgba(0,0,0,0.2)
}

/* Pricing header */
.price .header {
  color: white;
  font-size: 25px;
}

.price .free {
  background-color: #111;
}

.price .basic {
  background-color: #055ada
}

.price .pro {
  background-color: #4CAF50;
}

/* List items */
.price li {
  border-bottom: 1px solid #eee;
  padding: 20px;
  text-align: center;
}

/* Grey list item */
.price .grey {
  background-color: #eee;
  font-size: 20px;
}

/* The "Sign Up" button */
.button {
  border: none;
  color: white;
  padding: 10px 25px;
  text-align: center;
  text-decoration: none;
  font-size: 18px;
}

/* Change the width of the three columns to 100%
(to stack horizontally on small screens) */
@media only screen and (max-width: 600px) {
  .columns {
    width: 100%;
  }
}
</style>